'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: theme.display,
            position: 'relative',
            textAlign: 'left',
            color: theme.color,
            zoom: 1,
            width: theme.width,
            minWidth: theme.minWidth,

            '&:after': {
                clear: 'both',
                content: '""',
                display: 'block',
                height: 0
            }
        },
        field: {
            paddingRight: theme.paddingRight,
            paddingLeft: theme.paddingLeft,
            paddingTop: theme.paddingTop,
            paddingBottom: theme.paddingBottom,
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            position: 'relative',
            color: theme.color,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight
        },
        label: {
            color: theme.labelColor,
            fontSize: theme.labelFontSize,
            lineHeight: theme.labelLineHeight,
            textAlign: 'left',
            overflow: 'hidden',
            textWrap: 'none',
            whiteSpace: 'nowrap',
            wordWrap: 'normal',
            fontFamily: theme.fontFamily
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        label: (0, _aphroditeJss.css)(styleList.label),
        field: (0, _aphroditeJss.css)(styleList.field)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        display: 'inline-block',
        color: theme.tFilled,
        fontFamily: theme.fontFamily,
        fontSize: theme.tsNormal,
        fontWeight: theme.twNormal,
        lineHeight: 1.5,
        paddingRight: 0,
        paddingLeft: 0,
        paddingTop: theme.gutter + 'px',
        paddingBottom: theme.gutter + 'px',

        labelColor: theme.tLabel,
        labelFontSize: theme.tsXSmall,
        labelLineHeight: theme.tlXSmall,

        errorLabelColor: theme.tError,
        width: 'auto',
        minWidth: 'auto'
    };
};